import { GlobalStyles } from '@shared/theme';

const BackgroundStyle = () => (
  <GlobalStyles
    styles={({ breakpoints, palette }) => ({
      html: {
        [breakpoints.down('md')]: {
          backgroundColor: `${palette.primary.main} !important`,
        },
        [breakpoints.up('md')]: {
          backgroundColor: palette.neutrals[300],
          backgroundImage:
            'linear-gradient(180deg, rgba(255,255,255) 55%, rgba(239,242,243,1) 65%)',
        },
      },
    })}
  />
);

export default BackgroundStyle;
